<script setup>
import ShowOptions from '@components/show/show-options'

defineProps({
    show: {
        type: Object,
        default: () => {},
    },
})
</script>

<template>
    <div>
        <div class="tile-wrapper">
            <div class="tile-content">
                <BaseLink :to="{ name: 'show', params: { id: show.id } }">
                    <BaseResourceImage
                        :resource="show"
                        class="image"
                        :should-lazyload="false"
                    />
                </BaseLink>
            </div>
            <div
                class="options"
                @click.prevent="() => {}"
            >
                <BaseDropdown :padded="false">
                    <template #trigger>
                        <BaseButton
                            :modifiers="{ autoWidth: true, transparent: true, dots: true }"
                            aria-label="Options"
                            button-type="tag"
                            size="small"
                        />
                    </template>
                    <template #dropdown>
                        <div>
                            <ShowOptions :show="show" />
                        </div>
                    </template>
                </BaseDropdown>
            </div>
        </div>
        <BaseLink
            v-if="show && show.title"
            class="title show-link"
            :to="{ name: 'show', params: { id: show.id } }"
        >
            <div class="title">{{ show.title }}</div>
        </BaseLink>
        <div
            v-if="show.artist"
            class="artist"
        >
            <BaseLink :to="{ path: `/artist/${show.artist.url}/${show.artist.id}` }">
                {{ show.artist.title }}
            </BaseLink>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tile-wrapper {
    position: relative;

    &:hover {
        .tile-content::after {
            opacity: 0.5;

            @include transition(opacity, base);
        }

        .options {
            opacity: 1;

            @include transition(opacity, base);
        }
    }
}

.tile-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    overflow: hidden;
    border-radius: $size-radius-artwork;

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        content: '';
        background: $c-surface-raised;
        opacity: 0;

        @include transition(opacity, slow);
    }
}

.options {
    position: absolute;
    top: $s-m;
    right: $s-m;
    z-index: $layer-dropdown-z-index;
    opacity: 1;

    @include transition(opacity, slow);
}

.image {
    @include center;

    width: 100%;
}

.title {
    @extend %contentTitleM;

    margin-top: $size-grid-padding;
    line-height: 24px;
    text-align: center;
}

.artist {
    @extend %contentSubtitleM;

    text-align: center;

    a {
        color: $c-text-secondary;
    }
}

@include tablet {
    .tile-content {
        height: 200px;
    }
}

@include desktop {
    .options {
        opacity: 0;
    }
}
</style>
